import React from "react";
import {
  Layout,
  Typography,
  Row,
  Col,
  Space,
  Tooltip,
  message,
  Button,
  Modal,
  Card,
  Input,
  List,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";

import config from "../config";

import withRouter from "../withRouter";
import DeleteConfirm from "./DeleteConfirm";
import { DeleteFilled, PlusOutlined } from "@ant-design/icons";

import { Link, redirect } from "react-router-dom";
import { postApi } from "../components/Utility";
const { Content } = Layout;
const { Title, Text, Paragraph } = Typography;

class AiAssistant extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      question: "",
      response: null,
      loading: false,
      data: "",
    };
  }
  async componentDidMount() {}

  handleAsk = async () => {
    const { question } = this.state;

    // Validation
    if (!question.trim()) {
      message.warning("Please enter a question before asking.");
      return;
    }

    // Start loading
    this.setState({ loading: true, response: null, data: "" });

    try {
      var response = await postApi
        .getClient()
        .get("https://dolphin.trackeazy.com/clara-api/", {
          params: {
            nl_query: encodeURIComponent(question),
            userId: this.props.getUserData().userId,
            companyId: this.props.getUserData().userCompanyId,
            isadmin: this.props.getUserData().isadmin,
          },
        });

      const contentType = response.headers["content-type"];
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Unexpected response format");
      }

      const summary = response.data.summary || "No data returned from server.";
      this.setState({ data: summary, loading: false });
    } catch (error) {
      console.log("API error:", error);

      message.error("Something went wrong. Please try again later.");
    } finally {
      this.setState({ loading: false });
    }
  };

  onInputChange = (e) => {
    this.setState({ question: e.target.value });
  };

  onInputSearch = () => {
    this.handleAsk();
  };

  render() {
    const { question, response, loading, data } = this.state;

    const lines = data.split("\n").filter((line) => line.trim() !== "");

    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_AI_")}
              </div>
            </Col>
            
          </Row>
        </div> */}
        <Layout
          style={{
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Content style={{ maxWidth: 800, width: "100%" }}>
            <Card style={{ boxShadow: "none", border: "none" }}>
              <Title level={2}>Ask your question</Title>

              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  marginBottom: "24px",
                  alignItems: "center",
                }}
              >
                <Input
                  placeholder="Question"
                  value={question}
                  onChange={this.onInputChange}
                />
                <Button
                  type="primary"
                  onClick={this.handleAsk}
                  loading={loading}
                >
                  Ask
                </Button>
              </div>
              {data && (
                <div style={{ whiteSpace: "pre-line" }}>
                  {lines.map((line, index) => {
                    const trimmed = line.trim();

                    if (index === 0) {
                      return (
                        <p key={index}>
                          <strong style={{ fontSize: "16px" }}>
                            {trimmed}
                          </strong>
                        </p>
                      );
                    }

                    if (index === 1) {
                      return (
                        <p key={index}>
                          <strong style={{ fontSize: "16px" }}>
                            {trimmed}
                          </strong>
                        </p>
                      );
                    }

                    if (trimmed === "Recommendations:") {
                      return (
                        <p key={index}>
                          <strong style={{ fontSize: "16px" }}>
                            {trimmed}
                          </strong>
                        </p>
                      );
                    }

                    return <p key={index}>{trimmed}</p>;
                  })}
                </div>
              )}
              {/* {response && (
              <>
                <Title level={4}>
                  Hi there! After reviewing your fleet, here's what's on the radar for oil maintenance:
                </Title>

                <Title level={5}>Due for Oil Maintenance:</Title>
                <List
                  size="small"
                  bordered={false}
                  dataSource={response.dueList}
                  renderItem={(item, index) => (
                    <List.Item>
                      {index + 1}. Vehicle ID: {item.id} - Status: {item.status}
                    </List.Item>
                  )}
                  style={{ marginBottom: 24 }}
                />

                <Title level={5}>Recommendations:</Title>
                <ul>
                  {response.recommendations.map((rec, i) => (
                    <li key={i}>
                      <Text>{rec}</Text>
                    </li>
                  ))}
                </ul>

                <Text type="secondary">
                  Remember, staying on top of proactive maintenance is key to keeping your fleet running smoothly!
                </Text>
              </>
            )} */}
            </Card>
          </Content>
        </Layout>
      </>
    );
  }
}
AiAssistant.contextType = StoreContext;
export default observer(withRouter(AiAssistant));
